




























































































    import {Component, Vue, Mixins} from "vue-property-decorator";
    import AuthMixin from "./../mixins/AuthMixin";
    import { BlogPostFull, BlogPostListing, BlogPostReadOnly, BlogService, CommentRequest, UpdateBlogPostRequest } from "./../services/blog.service";
    import BlogList from "@/components/blog/List.vue";
    import { AuthService, User } from "../services/auth.service";
    import ArticleViewer from "@/components/ui/ArticleViewer.vue";
    import MarkdownEditor from "@/components/ui/MarkdownEditor.vue";
    import FormGroup from "@/components/ui/forms/FormGroup.vue";
    import {slugify} from "../services/slug.service";
    import { HashMap } from "../services/base.service";
    import CategoryService, { ICategory } from "../services/category.service";
    import NotificationMixin from "../mixins/NotificationMixin";
    import {UserService, MinimalUser} from "../services/user.service";
    import Set from "../structures/set.structure";
    import Comments from "@/components/Comments.vue";
    import CommentForm from "@/components/CommentForm.vue";

    interface BlogPostRequest {
    title: string;
    slug: string;
    content: string;
    usersAllowedToEdit: MinimalUser[];
    categories: ICategory[];
}

    @Component({
        components: {
            FormGroup,
            BlogList,
            MarkdownEditor,
            Comments,
            CommentForm,
            ArticleViewer,
        }
    })
    export default class BlogPost extends Mixins(AuthMixin, NotificationMixin) {
        private initialized = false;
        private canCreate: boolean = false;
        private service!: BlogService;
        private user!: User;
        private post!: BlogPostReadOnly | BlogPostFull;

        private editing: boolean = false;

        private request!: BlogPostRequest;
        private errors: HashMap<string> = {};

        private loading: boolean = false;

        private users: MinimalUser[] = [];
        private categories: ICategory[] = [];

        private selectedUser: MinimalUser | null = null;
        private selectedCategory: ICategory | null = null;

        private comments: Comment[] = [];

        private canEdit() {
            if (!this.user) return false;
            if (!("author" in this.post)) return false;
            if (this.post.author.id === this.user.id) return true;
            if (this.post.allowedToEdit.filter(x => x.id === this.user.id).length > 0) return true;
            return false;
        }

        private updateSlug() {
            this.request.slug = slugify(this.request.title);
            this.$forceUpdate();
        }

        private async loadUsers() {
            const userService = new UserService();
            const res = await userService.get();
            if (res.success) this.users = res.result;
            console.log(this.users);
        }

        private async loadCategories() {
            const categoryService = new CategoryService();
            const res = await categoryService.get();
            if (res.success) this.categories = res.result;
            console.log(this.categories);
        }

        private addCategory() {
            if (this.selectedCategory) {
                const catSet = new Set<ICategory>((cat) => cat.id, this.request.categories);
                catSet.push(this.selectedCategory);
                this.selectedCategory = null;
                this.request.categories = catSet.self;
                this.$forceUpdate();
            }
        }

        private removeCategory(category: ICategory) {
            const catSet = new Set<ICategory>((cat) => cat.id, this.request.categories);
            catSet.remove(category);
            this.request.categories = catSet.self;
            this.$forceUpdate();
        }

        private addUser() {
            if (this.selectedUser) {
                const userSet = new Set<MinimalUser>((user) => user.id, this.request.usersAllowedToEdit);
                userSet.push(this.selectedUser);
                this.selectedUser = null;
                this.request.usersAllowedToEdit = userSet.self;
                this.$forceUpdate();
            }
        }

        private removeUser(user: MinimalUser) {
            const userSet = new Set<MinimalUser>((user) => user.id, this.request.usersAllowedToEdit);
            userSet.remove(user);
            this.request.usersAllowedToEdit = userSet.self;
            this.$forceUpdate();
        }

        private initRequest() {
            this.request = {
                title: this.post.title,
                slug: this.post.slug,
                content: this.post.content,
                usersAllowedToEdit: (this.post as BlogPostFull).allowedToEdit,
                categories: this.post.categories,
            };

            console.log(this.request);
        }

        private async loadComments() {
            const res = await this.service.getComments(this.post.slug);
            if (res.success) {
                const raw = res.result;
                const map = {}
                const roots = [];

                for (let i = 0; i < raw.length; i++) {
                    // @ts-ignore
                    map[raw[i].id] = i;
                    raw[i]['children'] = [];
                }

                for (let i = 0; i < raw.length; i++) {
                    const node = raw[i];
                    if (node.parentComment) {
                        // @ts-ignore
                        raw[map[node.parentComment.id]].children.push(node);
                    } else {
                        roots.push(node);
                    }
                }

                this.comments = roots;
                console.log(this.comments);
            }
        }

        private get submitComment() {
            return (req: CommentRequest) => {
                return this.service.createComment(this.post.slug, req);
            }
        }

        private async created() {
            this.service = new BlogService();
            // @ts-ignore
            this.editing = this.$route.query.mode && this.$route.query.mode === 'edit';
            const res = await this.service.getOne(this.$route.params.id);

            // @ts-ignore
            this.user = await this.getSelf();

            if (res.success) {
                this.post = res.result as BlogPostReadOnly | BlogPostFull;
                this.loadComments();

                if (this.editing) {
                    this.errors = {};
                    // @ts-ignore
                    
                    if (!this.canEdit()) {
                        this.$router.replace({name: 'Unauthorized'});
                    }
                    this.initRequest();
                    this.loadUsers();
                    this.loadCategories();
                }

            } else {
                this.$router.replace({name: 'PageNotFound'});
            }
            console.log(this.post);
            this.initialized = true;
        }

        private mounted() {
            if (this.$route.hash) {
                const el = document.querySelector(this.$route.hash);
                el && el.scrollIntoView();
            }
            this.$forceUpdate();
        }
        
        private async save() {
            this.errors = {};
            this.loading = true;
            const res = await this.service.put((this.post as BlogPostFull).id, {
                ...this.request,
                usersAllowedToEditIds: this.request.usersAllowedToEdit.map(x => x.id),
                categoryIds: this.request.categories.map(x => x.id),
            });
            if (res.success) {
                this.notifySuccess("Post saved successfully");
            } else {
                this.notifyError("Failed to save post");
                this.errors = res.error;
            }
            this.loading = false;
        }

        private async submit() {
            this.save();
        }
    }
